import {
  Briefcase,
  ClipboardCheck,
  Heart,
  Plus,
  Receipt,
  User,
} from "lucide-react";
import { Navigate, Route, Routes } from "react-router-dom";

import { ApplicantList } from "@/features/applications";
import { useCurrentUser, useLogout } from "@/features/auth";
import { FavouritesPage } from "@/features/favourites";
import { VenueInvoiceDetailPage, VenueInvoicesPage } from "@/features/invoices";
import { EditShiftPage, PostShiftForm, ShiftDetail, ShiftManagement } from "@/features/shifts";
import { VenueTimesheetsPage } from "@/features/timesheets";
import { useVenueProfile, VenueProfileView } from "@/features/venues";
import { AppShell, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/shared/ui";

function PostShiftPage() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Post a shift</CardTitle>
        <CardDescription>
          Set the role, time, and pay rate. Approved workers can apply right away.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <PostShiftForm />
      </CardContent>
    </Card>
  );
}

export function VenueHomePage() {
  const { data: user } = useCurrentUser();
  const { data: profile, isLoading: profileLoading } = useVenueProfile();
  const logout = useLogout();

  // Force new venues through onboarding before they can post shifts.
  // Avoid a flicker by waiting on the profile fetch.
  if (profileLoading) {
    return null;
  }
  if (profile && !profile.onboarding_completed_at) {
    return <Navigate to="/venue/onboarding" replace />;
  }

  return (
    <AppShell
      roleLabel="Venue"
      userEmail={user?.email}
      onLogout={logout}
      tabs={[
        { to: "/venue", label: "Shifts", icon: Briefcase },
        { to: "/venue/post", label: "Post", icon: Plus },
        { to: "/venue/timesheets", label: "Timesheets", icon: ClipboardCheck },
        { to: "/venue/invoices", label: "Invoices", icon: Receipt },
        { to: "/venue/favourites", label: "Favourites", icon: Heart },
        { to: "/venue/profile", label: "Profile", icon: User },
      ]}
    >
      <Routes>
        <Route index element={<ShiftManagement />} />
        <Route path="post" element={<PostShiftPage />} />
        <Route path="shifts/:id" element={<ShiftDetail />} />
        <Route path="shifts/:id/edit" element={<EditShiftPage />} />
        <Route path="shifts/:id/applicants" element={<ApplicantList />} />
        <Route path="timesheets" element={<VenueTimesheetsPage />} />
        <Route path="invoices" element={<VenueInvoicesPage />} />
        <Route path="invoices/:id" element={<VenueInvoiceDetailPage />} />
        <Route path="favourites" element={<FavouritesPage />} />
        <Route path="profile" element={<VenueProfileView />} />
        <Route path="*" element={<Navigate to="/venue" replace />} />
      </Routes>
    </AppShell>
  );
}
